import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { LotGetSummaryByProjectIdStageIdLotId, LotGetSummaryByProjectIdStageIdLotIdResponse } from '../../api/dtos';


const getData = (response?: SWRResponse<LotGetSummaryByProjectIdStageIdLotIdResponse, LotGetSummaryByProjectIdStageIdLotIdResponse>) => {
    return response?.data
};
const getError = (response?: SWRResponse<LotGetSummaryByProjectIdStageIdLotIdResponse, LotGetSummaryByProjectIdStageIdLotIdResponse>) => (response?.error ?? response?.data)?.responseStatus;

const useLotDetailsByProjectIdStageIdLotId = (projectId?: number, stageId?: number, lotId?: number, configuration?: SWRConfiguration<LotGetSummaryByProjectIdStageIdLotIdResponse, LotGetSummaryByProjectIdStageIdLotIdResponse>) => {
    
    const request = useMemo(() => {
        return projectId && stageId && lotId ?
            () => {
                return new LotGetSummaryByProjectIdStageIdLotId({ projectId, stageId, lotId });
            } :
            undefined;
    }, [projectId, stageId, lotId])

    return useGet(request, { getData, getError }, configuration);
}

export default useLotDetailsByProjectIdStageIdLotId;